import { render } from "./TheDemandTerms.vue?vue&type=template&id=0e2bd67b"
import script from "./TheDemandTerms.vue?vue&type=script&lang=js"
export * from "./TheDemandTerms.vue?vue&type=script&lang=js"

import "./TheDemandTerms.vue?vue&type=style&index=0&id=0e2bd67b&lang=scss"
script.render = render

export default script